import React from 'react'

const MetaHash: React.FC<any> = () => {
  return (
    <img src="https://s2.coinmarketcap.com/static/img/coins/64x64/3756.png" width="20px" height="20px" alt="MetaHash" />
  )
}

export default MetaHash
